'use strict';

var _image = require('../Image/image');

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = require('react');
var createReactClass = require('create-react-class');

var LocalizeMixin = require("../../localization/CommonLocalizationMixin");

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin],
    getPromoImageUrl: function getPromoImageUrl(urlRoot, imageId) {
        return urlRoot + imageId + '_large_US_en.jpg';
    },

    render: function render() {
        var buttonDisabled = !this.props.item.menuItemId;
        var config = require('../../lib/config');
        var urlRoot = config.urls.images.campaignItemsWeb;
        var imgUrl = this.getPromoImageUrl(urlRoot, this.props.item.image);
        var noClick = buttonDisabled ? 'no-click' : '';

        return React.createElement(
            'div',
            { className: 'col-md-6 col-sm-8 col-xs-12 categoryItemContainer lto-item' },
            React.createElement(
                'button',
                { className: "categoryItem " + noClick,
                    disabled: buttonDisabled,
                    onClick: this.onClick },
                React.createElement(
                    'div',
                    { className: 'image' },
                    React.createElement(_image2.default, {
                        src: imgUrl,
                        alt: this.getLocalizedText('ada_limited_time_offer'),
                        id: 'lto-' + this.props.item.productId + '-img',
                        backupImage: "/images/common/lto_placeholder.png" })
                )
            )
        );
    },

    onClick: function onClick() {
        if (this.props.item.menuItemId) {
            this.props.onClickHandler(this.props.item);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/menu/promoItem.js
// module id = 827
// module chunks = 0